var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes()},[_c('AuthScreen',[_c('RegisterForm',{attrs:{"slot":"formBox"},slot:"formBox"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }